export function isNullOrEmpty(o: any | any[]) {
    return Array.isArray(o) ? o.length == 0 : isNullOrUndefined(o);
}

export function isNullOrUndefined(o: any){
    return (o === undefined || o === null);
}